// extracted by mini-css-extract-plugin
export default {"aboutH3":"Home_aboutH3__jNbVJ","unordered":"Home_unordered__N6Td9","paraP":"Home_paraP__EGErW"};